import { z } from 'zod';
import { InventoryAdjustReason } from '../../constants/inventory-adjust-reason.js';
import { ADJUST_FIELDS } from './adjust-fields.js';
import { INVENTORY_ADJUST_CONSTRAINTS as LIMITS } from './constraints.js';
import { isAdjustReasonAllowed } from './is-adjust-reason-allowed.js';
/** A cause that names nothing on its own has to be written out instead. */
export const VARIANCE_NARRATIVE_REQUIRED_REASONS = [
    InventoryAdjustReason.OTHER,
    InventoryAdjustReason.UNEXPLAINED_ACCEPTED,
];
const tooMany = `${LIMITS.varianceRows.label}: close at most ${LIMITS.varianceRows.max} at once.`;
/**
 * Closes one or more open variances with a single cause. Which direction each one went is the
 * server's to check — the caller holds log ids, not quantities — so the schema only rejects a
 * reason that fits neither direction.
 */
export const explainCountVariancesInputSchema = z
    .object({
    inventoryLogIds: z
        .array(ADJUST_FIELDS.id('Variance'))
        .min(1, 'Choose at least one variance to close.')
        .max(LIMITS.varianceRows.max, tooMany),
    reasonId: ADJUST_FIELDS.reasonId(),
    explanation: ADJUST_FIELDS.explanation(),
})
    .superRefine((value, context) => {
    if (!isAdjustReasonAllowed('VARIANCE_UP', value.reasonId) &&
        !isAdjustReasonAllowed('VARIANCE_DOWN', value.reasonId)) {
        context.addIssue({
            code: 'custom',
            message: 'That reason is not a cause a count variance can be closed with.',
            path: ['reasonId'],
        });
    }
    if (VARIANCE_NARRATIVE_REQUIRED_REASONS.includes(value.reasonId) && value.explanation == null) {
        context.addIssue({
            code: 'custom',
            message: 'Write out what happened when the cause is Other or Unexplained.',
            path: ['explanation'],
        });
    }
    const seen = new Set();
    value.inventoryLogIds.forEach((inventoryLogId, index) => {
        if (seen.has(inventoryLogId.toLowerCase())) {
            context.addIssue({
                code: 'custom',
                message: 'That variance is already in this list.',
                path: ['inventoryLogIds', index],
            });
        }
        seen.add(inventoryLogId.toLowerCase());
    });
});
//# sourceMappingURL=explain-variance-input.js.map